import Vue from "vue";
import api from "@/api";

export default {
	actions: {
		async CheckLogin(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.CheckLogin,
				data: entry,
			});

			return response.data;
		},
		async GetUserList() {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetUserList,
			});
			return response.data;
		},
		async GetUser(_, entryId) {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetUser + entryId,
				data: entryId,
			});
			return response.data;
		},
		async CreateUser(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.CreateUser,
				data: entry,
			});

			return response.data;
		},
		async UpdateUser(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UpdateUser,
				data: entry,
			});
			return response.data;
		},
		async DeleteUser(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.DeleteUser,
				data: entry,
			});
			return response.data;
		},
	},
};
